// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentContactPersonCard_wrapper__g-vym","landlord":"ApartmentContactPersonCard_landlord__+5fLj"};